import { initialState } from "../store/initialState";
import { AnyAction } from "redux";
import { internalActionKeys } from "../actions/internalActionKeys";
import { ReportDto } from "../types/report";

export default function failedAppointmentAttemptsReportReducer(
  state: ReportDto = initialState.failedAppointmentAttemptsReport,
  action: AnyAction
): ReportDto {
  switch (action.type) {
    case internalActionKeys.GET_FAILED_APPOINTMENT_ATTEMPTS_REPORT_SUCCESS:
      return action.report;
    default:
      return state;
  }
}
